import { createContext, useState } from 'react';

export const TemplateContext = createContext();
export const TemplateProvider = ({ children }) => {
    const [isCreatedTemplate, setIsCreatedTemplate] = useState(null);
    const [isEditedTemplate, setIsEditedTemplate] = useState(null);
    const [isDeletedTemplate, setIsDeletedTemplate] = useState(null);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    
    const addTemplate = ( value ) => { setIsCreatedTemplate(value) };
    const clearSuccess = () => {
        setIsCreatedTemplate(null);
        setIsDeletedTemplate(null)
        setIsEditedTemplate(null)
        setSelectedTemplate(null)
    }
    const setTemplate = ( template ) => { 
        setSelectedTemplate(template)
    }
    return (
        <TemplateContext.Provider value={{ 
            isCreatedTemplate, 
            addTemplate, 
            clearSuccess,

            selectedTemplate,
            setTemplate,
            
            isDeletedTemplate,
            setIsDeletedTemplate,

            isEditedTemplate,
            setIsEditedTemplate 
            
         }}>
            {children}
        </TemplateContext.Provider>
    );
};
